import { createContext } from "react";
import { TCredentialForm, TInitialState, TIssuerNameProps, TMerchant } from "./contextTypes";
import { InstallmentsProps } from "../../pages/Installments/InstallmentsForm/types";


export type TContextProp = {
  state: TInitialState,
  createMiddleman: (merchant: TMerchant) => void,
  putMerchant: (id: string | number) => void,
  setConfigureKey: (payload: TCredentialForm) => void,
  sendEmailPayway: () => void,
  sendEmailSuccess: (jwe: string | undefined) => void,
  updateStateData: (payload: any) => void,
  sendInstallmentsData: (jwe: string | undefined, installmentsBody: InstallmentsProps, blockedIssuersBody: TIssuerNameProps) => void;
  getMerchantDataFromJwe: (jwe: string | undefined) => any;
}

const GlobalContext = createContext<TContextProp>({} as TContextProp);


export default GlobalContext;